import moment from 'moment';

const Formatter = {

    smartPluralize: function (count, str) {
        if (count > 1) {
            str = str + 's';
        }

        return `${count} ${str}`;
    },

    pluralize: function (str, count) {
        return count > 1 ? (str + 's') : str;
    },

    getHumanTime: function (dateTsFrom, dateTsTo, options) {
        var result, mathFunc = Math.round;

        if (options && options.doNotRound) {
            mathFunc = parseInt;
        }

        var dayDiff = moment(dateTsTo).diff(dateTsFrom, 'seconds');
        if (dayDiff < 3600) {
            result = { count: mathFunc(dayDiff / 60), units: 'minute' };

        } else if (dayDiff < 86400) {
            result = { count: mathFunc(dayDiff / 60 / 60), units: 'hour' };
        }
        else {
            result = { count: mathFunc(dayDiff / 60 / 60 / 24), units: 'day' };
        }

        result.units = this.pluralize(result.units, result.count);

        return result;
    },
    getHumanTimeFormatted: function (dateTsFrom, dateTsTo, options) {
        var result = this.getHumanTime(dateTsFrom, dateTsTo, options),
            agoSuffix = '',
            inSuffix = '';

        if (result.count === 0) {
            result = 'a second';
            if (options && options.includeAgo) {
                agoSuffix = ' ago';
            }
            return result + agoSuffix;
        }

        if (options && options.allowYesterday) {
            if (result.count === 1 && result.units === 'day') {
                return 'yesterday';
            }
        }

        if (options && options.shortMins) {
            if (result.units === 'minute' || result.units === 'minutes') {
                result.units = 'min';
            }
        }

        if (options && options.includeAgo) {
            agoSuffix = ' ago';
        }

        if (options && options.includeIn) {
            inSuffix = 'in ';
        }

        if (options && options.displayOldDatesAsDates) {
            if (result.units === 'day' || result.units === 'days') {
                return moment(dateTsFrom).format(options.format);
            }
        }


        if (options && options.includeIn && options.accuracy === 'day') {
            if (result.units !== 'day' && result.units !== 'days') {
                return 'tomorrow';
            } else {
                result.count = result.count + 1;
                if (result.units === 'day') {
                    result.units = 'days';
                }
            }
        }

        if (options.shortMode) {
            if (result.units === 'day' || result.units === 'days') {
                result.units = 'd';
            }

            if (result.units === 'hour' || result.units === 'hours') {
                result.units = 'h';
            }
        }

        return inSuffix + result.count + ' ' + result.units + agoSuffix;
    },

    formatTimeForAudio: function (ms) {
        return moment(ms * 1000).format('mm:ss');
    },

    getShortTime: function (timeInfo, options) {
        if (timeInfo.split(' ').length >= 2) {
            timeInfo = timeInfo.split(' ')[0] + ' ' + timeInfo.split(' ')[1][0];
        }

        if (timeInfo === 'a s') {
            timeInfo = '1 s';
        }

        if (options && options.allowAgo) {
            timeInfo += ' ago';
        }

        return timeInfo;
    },
    getTimeDiff: function (startTs1, endTs2) {
        const startDate = moment(+startTs1);
        const endDate = moment(+endTs2);

        const duration = moment.duration(endDate.diff(startDate));

        const seconds = Math.floor(duration.asSeconds());
        const minutes = Math.floor(duration.asMinutes());
        const hours = Math.floor(duration.asHours());
        const days = Math.floor(duration.asDays());
        const months = Math.floor(duration.asMonths());
        const years = Math.floor(duration.asYears());

        if (seconds < 60) return `${seconds} secs`;
        if (minutes < 60) return `${minutes} mins`;
        if (hours < 24) return `${hours} hrs`;
        if (days < 30) return `${days} days`;
        if (months < 12) return `${months} months`;
        return `${years} years`;
    }
};

export default Formatter;
